
/*
 *
 * Date: 2025
 * Description: Script form , for scripts launch
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { ReactElement , ChangeEvent } from "react"
import { Box , Paper , Typography , TextField , MenuItem , Button} from "@mui/material"
import { i_script_form } from "../../interfaces/utility.interface"

const ScriptForm = ( props : i_script_form ) : ReactElement => {
    const handleField = ( event : ChangeEvent<HTMLInputElement> ) : void  => {
        const { name, value } = event.target
        props.setForm({...props.form, [name] : value})
    }
    const btnSubmit = { width: '100%', maxWidth : '300px' , marginLeft : 'auto' , marginRight : 'auto' , marginTop: '1vh'}
    const F : any = props.form
    const E : any = props.errors
    return (
        <Paper elevation={3} sx={{ padding : 5 , maxWidth : '800px' , marginLeft : 'auto' , marginRight : 'auto'}}>
        <Box sx={{ display : 'flex' , flexDirection : 'column'}}>
            <Box p={3}>
                <Typography>Maybe add a time when the script is started here , or other parameters like reset on</Typography>
            </Box>
            <TextField helperText={E.type} error={E.type !== '' ? true : false} select defaultValue={'default'} onChange={handleField} name={'type'}>
                <MenuItem value="default" disabled>Select a script</MenuItem>
                {
                    props.select_arr && props.select_arr.map((item : any, index : number) => (
                        <MenuItem key={index} value={item}>{item}</MenuItem>
                    ))
                }
            </TextField>
            <Button type="button" sx={btnSubmit} loading={props.loading} variant="contained" onClick={() => props.callback()}>Submit</Button>
        </Box>
    </Paper>
    )
}


export default ScriptForm;